import { createFileRoute } from "@tanstack/react-router";
import GSCIntegration from "@/pages/GSCIntegration";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/gsc-integration/")({
  head: () => routeHead("/de/gsc-integration/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <GSCIntegration />
  );
}
